import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as ContactInfoActions from '@staff-app/actions/contact-info.actions';
import * as EducationActions from '@staff-app/actions/education.actions';
import * as EligibilityAndAvailabilityActions from '@staff-app/actions/eligibility-and-availability.actions';
import * as ExperienceActions from '@staff-app/actions/experience.actions';
import * as LocationActions from '@staff-app/actions/location.actions';
import * as PortfolioActions from '@staff-app/actions/portfolio.actions';
import * as PositionActions from '@staff-app/actions/position.actions';
import { jobAppOpenStatusDTO } from '@staff-app/models/jobAppOpenStatusDTO';
import { StaffAppRoutesEnum } from '@staff-app/staff-app-routes-enum';
import { Logout } from '@store/actions';
import * as fromRoot from '@store/reducers';
import * as fromStaffApp from '@staff-app/reducers';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { BaseComponent } from '@shared/base.component';
import { GetJobAppOpenStatusInfo, GetJobAppProcessStatusInfo } from '@staff-app/actions/meta-info.actions';
import { GetLoggedInUserAndRoles } from '@store/actions/user.actions';

@Component({
    selector: 'idp2-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit {
    userAndRoleInfo$ = this.store.pipe(
        select(fromRoot.getLoggedinUserAndRoleInfo)
    );
    loggedIn$ = this.store.pipe(select(fromRoot.getIsLoggedIn));
    getCurrentUrl$ = this.store.pipe(select(fromRoot.getCurrentUrl));
    jobAppStatus$: Observable<jobAppOpenStatusDTO> = this.store.pipe(
        select(fromStaffApp.getJobAppOpenStatus)
    );
    jobAppProcessStatus$ = this.store.pipe(select(fromStaffApp.getJobAppProcessStatus));
    isEditMode$ = this.store.pipe(select(fromStaffApp.getIsJobAppCompleted));

    currentUrl: string = '';
    logoSrc = environment.appRoot + 'assets/id-logomark-white.svg';

    authData = sessionStorage.getItem('pulse.authorizationData');

    constructor(private store: Store<fromRoot.State>, private router: Router) {
        super();
    }

    ngOnInit() {
        this.subscriptions.push(this.getCurrentUrl$.subscribe(result => {
            this.currentUrl = result ?? '';
        }));

        this.subscriptions.push(this.jobAppStatus$.subscribe(jobAppOpenStatusDTO => {
            if (!jobAppOpenStatusDTO) {
                this.store.dispatch(new GetJobAppOpenStatusInfo());
                return;
            }
            else if (this.currentUrl.indexOf(StaffAppRoutesEnum.Intro) < 0 && (jobAppOpenStatusDTO.isBeforeOpen || jobAppOpenStatusDTO.isClosed)) {
                // if job application is not open redirect to intro page
                this.router.navigate([StaffAppRoutesEnum.Intro]);
            }
            else {
                this.subscriptions.push(this.loggedIn$.subscribe(isLoggedIn => {
                    if (isLoggedIn) {
                        this.subscriptions.push(this.userAndRoleInfo$.subscribe(currentUserAndRoleInfo => {
                            if (!currentUserAndRoleInfo) {
                                this.store.dispatch(new GetLoggedInUserAndRoles(false));
                            }
                            else {
                                this.store.dispatch(new GetJobAppProcessStatusInfo(currentUserAndRoleInfo.user.userID));
                            }
                        }));
                    }
                }));
            }
        }));

        this.subscriptions.push(this.jobAppProcessStatus$.subscribe(jobAppProcessStatus => {
            if (jobAppProcessStatus) {
                if (this.currentUrl.indexOf(StaffAppRoutesEnum.Intro) < 0 
                    && this.currentUrl.indexOf(StaffAppRoutesEnum.ChangePassword) < 0 
                    && !jobAppProcessStatus.isEditable) {
                    // if user is not on intro page and job application is not editable, redirect to intro page
                    this.router.navigate([StaffAppRoutesEnum.Intro]);
                }
            }
        }));

    }

    logout() {
        // const payload = {
        //   clearAllState: true,
        //   resetBrowseIdentifier: true
        // };
        // this.store.dispatch(new Logout(payload));
        this.router.navigate([StaffAppRoutesEnum.Login]);
    }
    back() {
        switch (this.currentUrl) {
            case StaffAppRoutesEnum.ContactInfo: {
                this.store.dispatch(new ContactInfoActions.NavigateAway());
                this.router.navigate([StaffAppRoutesEnum.Intro]);
                break;
            }
            case StaffAppRoutesEnum.Positions: {
                this.store.dispatch(new PositionActions.NavigateAway());
                this.router.navigate([StaffAppRoutesEnum.ContactInfo]);
                break;
            }
            case StaffAppRoutesEnum.LocationFinder: {
                this.store.dispatch(new LocationActions.NavigateAway());
                this.router.navigate([StaffAppRoutesEnum.Positions]);
                break;
            }
            case StaffAppRoutesEnum.LocationPreferences: {
                this.store.dispatch(new LocationActions.NavigateAway());
                this.router.navigate([StaffAppRoutesEnum.Positions]);
                break;
            }
            case StaffAppRoutesEnum.EligibilityAndAvailability: {
                this.store.dispatch(
                    new EligibilityAndAvailabilityActions.NavigateAway()
                );
                // TODO: Some logic need to done to check if user selected online only or not, online position will skip location pages
                //this.router.navigate([StaffAppRoutesEnum.LocationPreferences]);
                this.router.navigate([StaffAppRoutesEnum.Positions]);
                break;
            }
            case StaffAppRoutesEnum.Experience: {
                this.store.dispatch(new ExperienceActions.NavigateAway());
                this.router.navigate([StaffAppRoutesEnum.EligibilityAndAvailability]);
                break;
            }
            case StaffAppRoutesEnum.Education: {
                this.store.dispatch(new EducationActions.NavigateAway());
                this.router.navigate([StaffAppRoutesEnum.Experience]);
                break;
            }
            case StaffAppRoutesEnum.Portfolio: {
                this.store.dispatch(new PortfolioActions.NavigateAway());
                this.router.navigate([StaffAppRoutesEnum.Education]);
                break;
            }
            case StaffAppRoutesEnum.Submit: {
                this.router.navigate([StaffAppRoutesEnum.Portfolio]);
                break;
            }
            default: {
                // statements;
                break;
            }
        }
    }

    isShowBackButton() {
        return (
            this.currentUrl &&
            (this.currentUrl === StaffAppRoutesEnum.ContactInfo ||
                this.currentUrl === StaffAppRoutesEnum.Positions ||
                this.currentUrl === StaffAppRoutesEnum.LocationFinder ||
                this.currentUrl === StaffAppRoutesEnum.LocationPreferences ||
                this.currentUrl === StaffAppRoutesEnum.EligibilityAndAvailability ||
                this.currentUrl === StaffAppRoutesEnum.Experience ||
                this.currentUrl === StaffAppRoutesEnum.Education ||
                this.currentUrl === StaffAppRoutesEnum.Portfolio ||
                this.currentUrl === StaffAppRoutesEnum.Submit)
        );
    }
}
